<template>
  <div class="inputbox_container">
    <label :for="'#'+input_info.input_id">{{input_info.input_title}}</label>
    <input :type="input_info.input_type" :id="input_info.input_id" :required="input_info.require" :placeholder="input_info.placeholder" :class="{'check_value1' : input_content == '' || (!isEmptyObject(flag) && !flag[input_info.input_name]), 'check_value2' : pwd_check==false}" v-model="input_content">
    <p v-if="!pwd_check && input_info.notice">{{input_info.notice}}</p>
    <p v-if="input_info.notice2">{{input_info.notice2}}</p>
  </div>
</template>
<script>
export default {
  props:["input_info", "pwd_check", "flag"],
  data() {
    return {
      input_content: '',
    }
  },
  watch: {
    input_content(content){
      this.$emit('input_content', [content, this.input_info.input_name])
    }
  },
  methods: {
    isEmptyObject(obj){
      for(var key in obj){
        return false
      }
      return true
    }
  },
};
</script>
<style>
  .inputbox_container{
    margin-top: 20px;
  }
  .inputbox_container label{
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
    margin-bottom: 7px;
  }
  .inputbox_container input{
    display: block;
    width: 100%;
    font-size: 19px;
    line-height: 2;
    border: none;
    background: #abd8ff;
    padding-left: 5px;
  }
  /* .inputbox_container input.check_value2{
    background: #f88094;
  } */
  .inputbox_container input.check_value1,
  .inputbox_container input.check_value2 {
    background: #f88094;
  }
  .inputbox_container p:nth-of-type(1){
    font-size: 18px;
    font-weight: bold;
    line-height: 1.8;
    color: #ff0000;
    margin-bottom: 0;
  }
</style>